<template>
  <div class="navigation left-navigation">
    <div class="navigation-item">
      <router-link class="navigation-item--link" tag="span" :to="{name: 'building'}" exact @click.native="closeNav">Building</router-link>
      <router-link class="navigation-item--link" tag="span" :to="{name: 'residences'}" exact @click.native="closeNav">Residences</router-link>
      <router-link class="navigation-item--link" tag="span" :to="{name: 'penthouse'}" exact @click.native="closeNav">Penthouses</router-link>
      <router-link class="navigation-item--link" tag="span" :to="{name: 'neighborhood'}" exact @click.native="closeNav">Neighborhood</router-link>
      <router-link class="navigation-item--link" tag="span" :to="{name: 'availability'}" exact @click.native="closeNav">Availability</router-link>
      <router-link class="navigation-item--link" tag="span" :to="{name: 'team'}" exact @click.native="closeNav">Team</router-link>
      <router-link class="navigation-item--link" tag="span" :to="{name: 'press'}" exact @click.native="closeNav">Press</router-link>
      <router-link class="navigation-item--link" tag="span" :to="{name: 'contact'}" exact @click.native="closeNav">Inquiries</router-link>
        <div class="navigation-item--link call">
            <a href="tel:631-834-8523" class="navigation-item--link">Call</a>
        </div>
    </div>
    <div class="navigation-description">
<!--          <span class="navigation-description&#45;&#45;text">-->
<!--            Lorem Ipsum is simply dummy text of the printing and typesetting industry.-->
<!--            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley-->
<!--            of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap-->
<!--            into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of-->
<!--            Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker-->
<!--            including versions of Lorem Ipsum.-->
<!--          </span>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "LeftNavigation",
        methods: {
            closeNav () {
                this.$bus.emit('leftNavigationInside', false);
            }
        }
    }
</script>

<style scoped>

</style>
